import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { APIRequestStatus } from 'common-ts/dist/models/APIRequestStatus';
import { fetchShopProfile, TerbebasShopProfile } from '../terbebasApi';
import { applyStoreBranding } from '../storeBranding';

// The tenant store's public profile: name, branding, homepage layout.
// Fetched once at boot; drives NavBar branding and the homepage blocks.

export interface StoreProfileState {
  profile: TerbebasShopProfile | null;
  status: APIRequestStatus;
}

const initialState: StoreProfileState = {
  profile: null,
  status: APIRequestStatus.Idle,
};

export const fetchStoreProfile = createAsyncThunk('storeProfile/fetch', async () => {
  return fetchShopProfile();
});

export const storeProfileSlice = createSlice({
  name: 'storeProfile',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchStoreProfile.pending, (state) => {
        state.status = APIRequestStatus.RequestInProgress;
      })
      .addCase(fetchStoreProfile.fulfilled, (state, action) => {
        state.profile = action.payload;
        state.status = APIRequestStatus.Success;
        // Tab title + favicon, from the tenant's own settings.
        applyStoreBranding(action.payload);
      })
      .addCase(fetchStoreProfile.rejected, (state) => {
        state.status = APIRequestStatus.Failure;
      });
  },
});

export default storeProfileSlice.reducer;
